import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''

export const getTreeKpitype = async ({ token }) => {
  try {
    return await clientPublic
      .get(`kpitype/tree?lang=en&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeKpitypeV3 = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        `core/management/kpi-finance/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getKpitypeByCompanyId = async ({ company_id, token }) => {
  try {
    return await clientPublic
      .get(`kpitype?company_id=${company_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getKpitypeByCompanyIdV3 = async ({ company_id, token }) => {
  try {
    return await clientPublicService
      .get(`core/management/kpi-finance?company_id=${company_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getKpitypeInfoByCompanyId = async ({ id, token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/kpi-finance/info?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addKpitype = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('kpitype', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const addKpitypeV2 = async ({ params, token }) => {
  try {
    return await clientPublicService
      .post('/core/management/kpi-finance/kpi-type', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateKpitype = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`kpitype/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateKpitypeV2 = async ({ params, token }) => {
  try {
    return await clientPublicService
      .put(`/core/management/kpi-finance/kpi-type`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteKpitype = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .delete(`kpitype/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultCompanyV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .get('/core/management/company/dropdown', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
